import { useState } from "react"

import { Dropdown, Flex, Image, Typography } from "antd"
import FileDownload from "js-file-download"

import Icon from "../../Icon"
import { alertsColumnIconMap, ensureHttps } from "../../Utils/utils"
import Button from "../Button"
import { titleSortFilters } from "../titleSortFilters"

const { Text, Link } = Typography

const getRowSpan = (value, prevValue, countDuplicates) => {
  return value === prevValue ? 0 : countDuplicates
}

export const collapseRowCell = ({ value, index = 0, countDuplicates = 1, prevValue }) => {
  if (!countDuplicates) return {}
  return {
    rowSpan: index === 0 ? countDuplicates : getRowSpan(value, prevValue, countDuplicates)
  }
}

const ImagePreview = ({ files }) => {
  const [visible, setVisible] = useState(false)
  return (
    <Image.PreviewGroup
      items={files?.map(({ file_url }) => file_url)}
      preview={{
        visible,
        onVisibleChange: (value) => {
          setVisible(value)
        }
      }}
    >
      <Button type="link" onClick={() => setVisible(true)}>
        {files?.length}
      </Button>
      <Image
        width={24}
        height={24}
        src={files?.[0]?.file_url}
        style={{ borderRadius: 4, display: "none" }}
      />
    </Image.PreviewGroup>
  )
}

async function downloadArrFilesUrls(urls) {
  for (const url of urls) {
    try {
      const response = await fetch(url?.file_url)
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      const blob = await response.blob()

      FileDownload(blob, url?.file_name)

      await new Promise((resolve) => setTimeout(resolve, 300))
    } catch (error) {
      console.error(`Error downloading ${url}:`, error)
    }
  }
}

export const getBaseColumns = ({ t, isAdmin, onSelectRow, sorted, props = {} }) => ({
  id: {
    key: "sequence_number",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: null,
        sorter: true,
        icon: alertsColumnIconMap["sequence_number"],
        stateData: state,
        key: "sequence_number"
      }),
    dataIndex: "sequence_number",
    width: 100,
    fixed: "left",
    ...props["sequence_number"]
  },
  business_account: {
    key: "business_account",
    sorter: sorted ? sorted?.value : true,
    title: (state) =>
      titleSortFilters({
        title: isAdmin ? "Business account" : t("Business account"),
        sorter: sorted ? sorted?.value : true,
        icon: alertsColumnIconMap["business_account"],
        stateData: state,
        key: "business_account"
      }),
    dataIndex: "business_account",
    ellipsis: true,
    width: 200,
    render: (_, record) => {
      if (isAdmin) {
        return _ && (_?.business_account || _?.name) ? (
          <Flex gap={4}>
            <Text
              copyable={{
                tooltips: false,
                text: _?.business_account || _?.name
              }}
            />
            <Dropdown
              destroyPopupOnHide={true}
              menu={{
                items: [
                  { key: "business_account", label: "Business account" },
                  { key: "dashboard", label: "Users view" }
                ],
                onClick: ({ key, domEvent }) => {
                  domEvent?.stopPropagation()
                  onSelectRow(record, key)
                }
              }}
            >
              <Flex gap={8} align="center">
                <Text className="blue">{_?.business_account || _?.name}</Text>
                <Icon type="chevron_down_small" style={{ marginLeft: -4 }} />
              </Flex>
            </Dropdown>
          </Flex>
        ) : (
          "—"
        )
      } else {
        return _?.business_account
      }
    }
  },
  business_url: {
    key: "business_url",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: isAdmin ? "Business URL" : t("Business URL"),
        sorter: true,
        icon: alertsColumnIconMap["business_url"],
        stateData: state,
        key: "business_url"
      }),
    dataIndex: "business_url",
    ellipsis: true,
    width: 185,
    render: (_, record) => {
      let link = _ || record?.business_account?.url
      return (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "185px"
          }}
        >
          <Link href={ensureHttps(link)} target="_blank" onClick={(e) => e.stopPropagation()}>
            {link ? link : "—"}
          </Link>
        </div>
      )
    }
  },
  admin_comment: {
    key: "admin_comment",
    title: (state) =>
      titleSortFilters({
        title: "Comment",
        icon: alertsColumnIconMap["admin_comment"],
        stateData: state,
        key: "admin_comment"
      }),
    dataIndex: "admin_comment",
    width: 350,
    render: (_) => (_ ? <Text>{_}</Text> : "—")
  },
  admin_screenshots: {
    key: "admin_screenshots",
    title: (state) =>
      titleSortFilters({
        title: "Screenshots",
        icon: alertsColumnIconMap["admin_screenshots"],
        stateData: state,
        key: "admin_screenshots"
      }),
    dataIndex: "admin_screenshots",
    minWidth: 140,
    render: (_) => (_?.length ? <ImagePreview files={_} /> : "—")
  },
  attachments: {
    key: "attachments",
    title: (state) =>
      titleSortFilters({
        title: "Attachments",
        icon: alertsColumnIconMap["attachments"],
        stateData: state,
        key: "attachments"
      }),
    dataIndex: "attachments",
    width: 165,
    render: (files) =>
      files?.length ? (
        <Button
          type="link"
          onClick={() =>
            downloadArrFilesUrls(
              files?.map((file, i) => ({
                file_url: file?.file_url,
                file_name: file?.file_name || `file_${i + 1}`
              }))
            )
          }
        >
          {files?.length}
        </Button>
      ) : (
        "—"
      )
  }
})
